class ElementorImageGallery {
  constructor() {
    const galleries = document.querySelectorAll('.elementor-widget-image-gallery');

    if (galleries.length) {

      this.template = '<div class="elementor-lightbox-slideshow-data-wrapper">';
      this.template += '<div class="elementor-lightbox-slideshow-nslide">[image]/[total]</div>';
      this.template += '<div class="elementor-lightbox-slideshow-link"><a href="[link]">[label]</a></div>';
      this.template += '</div>';

      this.init();
    }
  }

  init() {
    const items = document.querySelectorAll('.gallery-item');

    if (items.length) {
      items.forEach(item => {
        item.addEventListener('click', () => {
          /* Workaround. There is no event launched on show slide */
          setTimeout(this.addTemplate, 100);
        });
      });
    }
  }

  addTemplate = () => {
    const wrapper = document.querySelector('.swiper-wrapper');
    const container = wrapper.querySelector('.swiper-zoom-container');
    const galleryLink = document.querySelector('#complete-gallery-link-id a');

    const total = wrapper.children.length - 2; /* There are two slides duplicated, so -2 needed */
    const link = galleryLink.getAttribute('href');
    const label = galleryLink.innerText;

    if (total > 0) {
      Array.from(wrapper.children).forEach(item => {
        const index = item.getAttribute('data-swiper-slide-index');
        const currentImage = index + 1;

        const el = document.createRange().createContextualFragment(this.template
          .replace(/\[image\]/g, currentImage)
          .replace(/\[total\]/g, total)
          .replace(/\[label\]/g, label)
          .replace(/\[link\]/g, link));

        container.appendChild(el);
      });
    }
  }
}

export default ElementorImageGallery;
